// extracted by mini-css-extract-plugin
export var logo = "logo-module--logo--gKIqX";